import React from 'react';
import { Wallet, FileUp, Calendar, FileText, CheckCircle } from 'lucide-react';

const VisitCardPage = () => {
  return (
    <div className="p-8 print:p-0">
      <div className="max-w-7xl mx-auto">
        {/* Page title - hidden when printing */}
        <h1 className="text-3xl font-bold mb-8 print:hidden">
          Vizitări Decizie Oncologică
        </h1>
        
        {/* Print instructions - hidden when printing */}
        <div className="mb-8 print:hidden">
          <p className="text-lg">
            Această pagină conține cărți de vizită care pot fi printate pe o hârtie A4.
          </p>
          <button 
            onClick={() => window.print()}
            className="mt-4 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
          >
            Printează
          </button>
        </div>

        {/* Visit cards grid - styled for printing */}
        <div className="grid grid-cols-2 gap-4 print:grid-cols-2 print:gap-0">
          {/* Multiple cards for printing */}
          {[...Array(8)].map((_, i) => (
            <div key={i} className="border border-gray-200 p-6 print:p-4 print:border-0 print:h-[140mm] print:flex print:flex-col print:justify-between print:bg-gradient-to-b print:from-blue-100 print:via-blue-50 print:to-white">
              {/* Logo */}
              <div className="flex justify-center mb-4">
                <img 
                  src="/logo-albastru.png" 
                  alt="Decizie Oncologica" 
                  className="h-16 print:h-12 object-contain"
                />
              </div>

              {/* Features section */}
              <div className="space-y-4 print:space-y-2">
                <h2 className="text-xl font-bold text-center print:text-lg">
                  Cum funcționează?
                </h2>

                <div className="space-y-4 print:space-y-2">
                  <div className="flex items-start gap-2">
                    <Wallet className="w-5 h-5 mt-0.5 flex-shrink-0 print:w-4 print:h-4" />
                    <p className="text-sm print:text-xs">
                      Îți faci cont pe decizieoncologica.ro
                    </p>
                  </div>

                  <div className="flex items-start gap-2">
                    <FileUp className="w-5 h-5 mt-0.5 flex-shrink-0 print:w-4 print:h-4" />
                    <p className="text-sm print:text-xs">
                      Trimiți documentele medicale
                    </p>
                  </div>

                  <div className="flex items-start gap-2">
                    <Calendar className="w-5 h-5 mt-0.5 flex-shrink-0 print:w-4 print:h-4" />
                    <p className="text-sm print:text-xs">
                      Echipa noastră le analizează
                    </p>
                  </div>

                  <div className="flex items-start gap-2">
                    <FileText className="w-5 h-5 mt-0.5 flex-shrink-0 print:w-4 print:h-4" />
                    <p className="text-sm print:text-xs">
                      Primești un raport personalizat
                    </p>
                  </div>
                </div>
              </div>

              {/* Why Choose Us Section */}
              <div className="mt-6 space-y-2 print:space-y-1">
                <h3 className="text-lg font-semibold text-center print:text-base">
                  De ce să alegi Decizie Oncologică?
                </h3>
                <ul className="space-y-1 print:space-y-0.5">
                  <li className="flex items-start gap-1">
                    <CheckCircle className="w-4 h-4 mt-0.5 flex-shrink-0 print:w-3 print:h-3" />
                    <span className="text-xs print:text-2xs">Acces la specialiști de top</span>
                  </li>
                  <li className="flex items-start gap-1">
                    <CheckCircle className="w-4 h-4 mt-0.5 flex-shrink-0 print:w-3 print:h-3" />
                    <span className="text-xs print:text-2xs">Evaluare multidisciplinară</span>
                  </li>
                  <li className="flex items-start gap-1">
                    <CheckCircle className="w-4 h-4 mt-0.5 flex-shrink-0 print:w-3 print:h-3" />
                    <span className="text-xs print:text-2xs">Rapid și confidențial</span>
                  </li>
                </ul>
              </div>

              {/* Pricing Section */}
              <div className="mt-4 space-y-1 print:space-y-0.5">
                <h3 className="text-lg font-semibold text-center print:text-base">
                  Cât costă?
                </h3>
                <p className="text-xs print:text-2xs text-center">
                  Costul unei consultații este de 1.000 de lei. În cazul în care aveți probleme financiare, suntem deschiși să analizăm cazul gratuit. Pentru acest lucru vă rog să ne contactați la: contact@decizieoncologica.ro
                </p>
              </div>

              {/* Website */}
              <div className="mt-4 text-center text-sm print:text-xs">
                www.decizieoncologica.ro
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default VisitCardPage;
